import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';
import { TimeBasedSettingForSpecificCallerDto } from '../../../dto/timebasedsetting/timebasedsettingforspecificcallerdto';

export interface TimeBasedSettingForSpecificCallerRequest extends APIRequest
{
    getTimeBasedSettingForSpecificCallerRequest(): TimeBasedSettingForSpecificCallerDto;
}

export class TimeBasedSettingForSpecificCallerRequestImpl extends APIRequestDtoImpl implements TimeBasedSettingForSpecificCallerRequest
{
    constructor(private timeBasedSettingForSpecificCallerData: TimeBasedSettingForSpecificCallerDto)
    {
        super();
    }

    getTimeBasedSettingForSpecificCallerRequest(): TimeBasedSettingForSpecificCallerDto
    {
        return this.timeBasedSettingForSpecificCallerData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/mytunes/timebasedsettingforspecificcaller/timebasedsettingforspecificcallerrequest.tsx